"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { Diagnosis } from "@/src/models/documents/referral";
import { getProvidersForDiagnosis, ProviderForDiagnosis } from "@/src/requests/diagnosis-providers";
export function useProvidersForDiagnostics(diagnosisList, departmentId) {
  const $ = _c(8);
  let t0;
  let t1;
  if ($[0] !== departmentId || $[1] !== diagnosisList) {
    t0 = ["providers-for-diagnosis", diagnosisList, departmentId];
    t1 = () => getProvidersForDiagnosis(diagnosisList, departmentId);
    $[0] = departmentId;
    $[1] = diagnosisList;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  const t2 = !!diagnosisList;
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: 300000
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
}